import { render } from "./SearchProductTextfield.vue?vue&type=template&id=795d8e9a&scoped=true"
import script from "./SearchProductTextfield.vue?vue&type=script&lang=js"
export * from "./SearchProductTextfield.vue?vue&type=script&lang=js"

import "./SearchProductTextfield.vue?vue&type=style&index=0&id=795d8e9a&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795d8e9a"]])

export default __exports__